module.exports = __webpack_public_path__ + "fonts/fontello-6ca0253cd9b16fcb5dcf9e7f7ca6c1ef.woff";